const template_name_ecom = document.querySelector("#im-in").getAttribute("data-template").trim();
$( document ).ready(function() {
    console.log( "ready!" );
  
//   $('.slider-for').each(function(key, item) {

//   var sliderIdName = 'slider' + key;
//   var sliderNavIdName = 'sliderNav' + key;

//   this.id = sliderIdName;
//   $('.featuresl')[key].id = sliderNavIdName;

//   var sliderId = '#' + sliderIdName;
//   var sliderNavId = '#' + sliderNavIdName;

//   $(sliderId).slick({
//     slidesToShow: 1,
//     slidesToScroll: 6,
//     arrows: true,
//     fade: false,
//     variableWidth: true,
//     asNavFor: sliderNavId
//   });

//   $(sliderNavId).slick({
//     slidesToShow: 2,
//     slidesToScroll: 2,
//     asNavFor: sliderId,
//     dots: false,
//     arrows: true,
//     centerMode: false,
//     focusOnSelect: true
//   });

// });
  
  
  
  //ecom-half-slide
  
  
    $('.ecom-half-slide').slick({
  dots: false,
  infinite: false,
  speed: 300,
  slidesToShow: 4,
  slidesToScroll: 4,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 4,
        slidesToScroll: 3,
        infinite: true,
        dots: false
      }
    },
    {
      breakpoint: 800,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 2
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1
      }
    }
    // You can unslick at a given breakpoint now by adding:
    // settings: "unslick"
    // instead of a settings object
  ]
});
  


  
  $(".ecom-logo-slide-row").show();
  
  
//   $(".relative_carousal").slick({
//         dots: true,
//         infinite: true,
//         slidesToShow: 4,
//         slidesToScroll: 3
//       });
  
  
  setTimeout(
    function() {
      
//       console.log('run suggest slick code');
//       $(".relative_carousal_sugg").show();
//        $('.relative_carousal_sugg').slick({
//   dots: false,
//   infinite: false,
//   speed: 300,
//   slidesToShow: 5,
//   slidesToScroll: 4,
//   responsive: [
//     {
//       breakpoint: 1024,
//       settings: {
//         slidesToShow: 5,
//         slidesToScroll: 3,
//         infinite: true,
//         dots: true
//       }
//     },
//     {
//       breakpoint: 600,
//       settings: {
//         slidesToShow: 3,
//         slidesToScroll: 2
//       }
//     },
//     {
//       breakpoint: 480,
//       settings: {
//         slidesToShow: 2,
//         slidesToScroll: 1
//       }
//     }
//     // You can unslick at a given breakpoint now by adding:
//     // settings: "unslick"
//     // instead of a settings object
//   ]
// });
      
      
      
      
      
    }, 10000);

  

  //==========================================
  
  $('.variable').slick({
    dots: true,
    infinite: true,
    variableWidth: true,
    slidesToShow: 10,
    slidesToScroll: 2,
    loop: true,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 9,
        slidesToScroll: 3,
        infinite: true,
        dots: true
      }
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 6,
        slidesToScroll: 2
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 1
      }
    }
    // You can unslick at a given breakpoint now by adding:
    // settings: "unslick"
    // instead of a settings object
  ]
});
  
   document.querySelectorAll('.variable .slick-cloned img').forEach(function(elem) {
    elem.removeAttribute("srcset")
  })
  //==========================================
  
  
 
  
  $(".ecom-text-card-1 .tcards img").show(); 
  
});




  // $(".logo-slide-ecom").slick({
  //       dots: true,
  //       infinite: true,
  //       variableWidth: true,
		// slidesToShow: 7,
  //       slidesToScroll: 3
  //     });


 $(".testSlider").slick({
        dots: true,
        infinite: true,
        variableWidth: true,
		slidesToShow: 20,
        slidesToScroll: 3
      });




$('.ecom-blog-post-home').slick({
    arrows: true,
    prevArrow: '<div class="home-blog-left-arrow"><img src="https://cdn.shopify.com/s/files/1/0592/3861/3149/files/left.png?v=1661155742" alt="left-arrow-icon" ></div>',
    nextArrow: '<div class="home-blog-right-arrow"><img src="https://cdn.shopify.com/s/files/1/0592/3861/3149/files/right.png?v=1661155742" alt="right-arrow-icon" ></div>',
    responsive: [
         {
             breakpoint: 9999,
             settings:"unslick",
         },
    {
      breakpoint: 768,
      settings: {
		dots: false,
		infinite: false,	
        slidesToShow: 2,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 550,
      settings: {
		dots: false,
		infinite: false,
        slidesToShow: 1,
        slidesToScroll: 1
      }
    }
  ]
});
		
/*
$(".logo-slide-ecom").slick({
    dots: false,
    infinite: false,
    variableWidth: true,
    slidesToShow: 4,
    slidesToScroll: 3,
    nav:true,
  placeholders:false,
      responsive: [
    {
      breakpoint: 1366,
      settings: {
        slidesToShow: 4,
        infinite: true,
        dots: false
      }
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 4,
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 4,
      }
    }
  ]
});
*/

$(".logo-slide-ecom").on("beforeChange",function(event, slick, currentSlide){
    console.log(currentSlide)
  if(currentSlide >= 21) {
    document.querySelector(`.logo-slide-ecom.osx-dock button.slick-next`).classList.add("slick-disabled") 
      document.querySelector(`.logo-slide-ecom.osx-dock button.slick-next`).disabled = true;
  } else {
    document.querySelector(`.logo-slide-ecom.osx-dock button.slick-next`).classList.remove("slick-disabled") 
      document.querySelector(`.logo-slide-ecom.osx-dock button.slick-next`).disabled = false;
  }
})





// blog post carousel ponds
let slick_for_blog_posts = {
    arrows: true,
    prevArrow: '<div class="home-blog-left-arrow"><img src="https://cdn.shopify.com/s/files/1/0592/3861/3149/files/left.png?v=1661155742" alt="left-arrow-icon" ></div>',
    nextArrow: '<div class="home-blog-right-arrow"><img src="https://cdn.shopify.com/s/files/1/0592/3861/3149/files/right.png?v=1661155742" alt="right-arrow-icon" ></div>',
    responsive: [
         {
             breakpoint: 9999,
             settings:"unslick",
         },
    {
      breakpoint: 768,
      settings: {
		dots: false,
		infinite: false,	
        slidesToShow: 2,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 550,
      settings: {
		dots: false,
		infinite: false,
        slidesToShow: 1,
        slidesToScroll: 1
      }
    }
  ]
};

const template_name = document.querySelector('#im-in').getAttribute("data-template");
if(template_name == 'page.ponds') {
  slick_for_blog_posts.prevArrow = '<div class="home-blog-left-arrow"><img src="https://cdn.shopify.com/s/files/1/0592/3861/3149/files/Group_187.png?v=1722847508" alt="left-arrow-icon" ></div>';
  slick_for_blog_posts.nextArrow = '<div class="home-blog-right-arrow"><img src="https://cdn.shopify.com/s/files/1/0592/3861/3149/files/Group_188.png?v=1722847508" alt="right-arrow-icon" ></div>';
}
$('.ecom-blog-post-ponds').slick(slick_for_blog_posts);



// slick slider for video grid
Array.from(document.querySelectorAll(`.ecom-video-grid.make_as_carousel`)).forEach(elem=>{
    const mobile_sliders = +elem.getAttribute("data-mobile-slides");
    const desktop_sliders = +elem.getAttribute("data-desktop-slides");

    const slick_slider_options = {
        arrows: true,
        prevArrow: '<div class="home-blog-left-arrow"><img src="https://cdn.shopify.com/s/files/1/0592/3861/3149/files/left.png?v=1661155742" alt="left-arrow-icon" ></div>',
        nextArrow: '<div class="home-blog-right-arrow"><img src="https://cdn.shopify.com/s/files/1/0592/3861/3149/files/right.png?v=1661155742" alt="right-arrow-icon" ></div>',
        slidesToShow: desktop_sliders,
            slidesToScroll: 1,
        responsive: [
        {
          breakpoint: 768,
          settings: {
    		dots: false,
    		infinite: false,	
            slidesToShow: mobile_sliders,
            slidesToScroll: 1
          }
        },
        {
          breakpoint: 550,
          settings: {
    		dots: false,
    		infinite: false,
            slidesToShow: 1,
            slidesToScroll: 1
          }
        }
      ]
    }

    const template_name = document.querySelector('#im-in').getAttribute("data-template");
    if(template_name == 'page.ponds') {
      slick_slider_options.prevArrow = '<div class="home-blog-left-arrow"><img src="https://cdn.shopify.com/s/files/1/0592/3861/3149/files/Group_187.png?v=1722847508" alt="left-arrow-icon" ></div>';
      slick_slider_options.nextArrow = '<div class="home-blog-right-arrow"><img src="https://cdn.shopify.com/s/files/1/0592/3861/3149/files/Group_188.png?v=1722847508" alt="right-arrow-icon" ></div>';
    }

    $(elem.querySelector('.video-container')).slick(slick_slider_options);
});